export function buildPostsQuery(options = {}) {
  return {
    per_page: options.limit || 12,
    page: options.page || 1,
    search: options.search || undefined,
    categories: options.categoryIds?.length ? options.categoryIds.join(",") : undefined,
    tags: options.tagIds?.length ? options.tagIds.join(",") : undefined,
    slug: options.slug || undefined,
    _embed: "wp:featuredmedia,wp:term",
  };
}

export function buildPagesQuery(options = {}) {
  return {
    per_page: options.limit || 20,
    slug: options.slug || undefined,
    search: options.search || undefined,
    _embed: "wp:featuredmedia",
  };
}

export function buildTaxonomyQuery(options = {}) {
  return {
    per_page: options.limit || 100,
    hide_empty: options.hideEmpty ?? false,
    search: options.search || undefined,
  };
}

export function buildAppsQuery(options = {}) {
  return {
    per_page: options.limit || 24,
    search: options.search || undefined,
    slug: options.slug || undefined,
    _embed: "wp:featuredmedia,wp:term",
  };
}
